
import Vue from 'vue';
import browserClient from '@slardar/web/maliva'
// import ByteDesign from '@bytedesign/web-vue';
// import ElementUI from 'element-ui';
import App from './App.vue';
import Cookies from 'js-cookie';
import router from './router/index';
import store from './store/index';
import i18n from './i18n/index'

import FBSignInButton from 'vue-facebook-signin-button'
import $settings from '@/settings.js';

import { reportLogAction, deviceType } from './util/public'

// import '@bytedesign/web-vue/dist/styles/index.css';
import "@/assets/iconfont/iconfont.css";
import './styles/element-variables.scss'
// 引入全局样式
import '@/styles/index.scss';
import '@/plugins/element.js'
import '@/plugins/vant';
// 全局配置
Vue.prototype.$settings = $settings;
Vue.prototype.$browser_UUID = '';

Vue.config.errorHandler = function (err) {
    const errorMsg = String(err);
    let eventId = 'global_main'
    console.log('@@init-global_main报错' ,errorMsg)
    const browserVer = {
        eventType: 'plat_init_global',
        eventId,
        eventLevel: 'error',
        eventTime: Math.round(new Date() / 1000),
        attr: JSON.stringify({ msg: errorMsg }),
    };
    reportLogAction(browserVer);
};
// Slardar 平台
window['browserClient'] = browserClient
const VUE_APP_ENVIRONMENT = window.VUE_APP_ENVIRONMENT,
RELEASE = ['release', 'grayRelease'], ONLINE = ['online', 'grayOnline'];
const browserId = localStorage.getItem('browserId') || Cookies.get('browserId') || 'unknown'
const PUID = Cookies.get('H5-PUID') || '';
let release

let adUrl = 'app.adjust.com/event';

if (RELEASE.includes(VUE_APP_ENVIRONMENT)) {
    try {
        release = window['Plat_Version'];
    } catch (e) {
        release = 'exception1.0.0';
    }
    browserClient('init', {
        bid: 'Girls_H5',
        userId: browserId,
        PUID,
        release,
        plugins: {
            ajax:{
                ignoreUrls:[adUrl],
            },
            fetch:{
                ignoreUrls:[adUrl],
            }
        }

    })
} else {
    try {
        release = 'ol.' + window['Plat_Version'];
    } catch (e) {
        release = 'ol.' + 'exception1.0.0';
    }
    browserClient('init', {
        bid: 'Girls_H5',
        userId: browserId,
        PUID,
        // release
        plugins: {
            ajax:{
                ignoreUrls:[adUrl],
            },
            fetch:{
                ignoreUrls:[adUrl],
            }
        },
        blankScreen: {
            rootSelector: 'body', // 开始计算得分的根元素选择器， 默认从body开始，针对检测部分组件白屏设置此参数
            autoDetect: true, // 是否自动检测
            threshold: 2, // 得分阈值，小于阈值则判断为白屏
            screenshot: true, // 是否在判断为白屏的时候截屏上报
        }
    })

}

const timestamp = new Date().getTime();
// window.cocosUrl = "https://cdn-ark-test.c4games.com/fzsn_h5/web-mobile/miniGame/";
// window.loadMini = "https://cdn-ark-test.c4games.com/fzsn_h5/web-mobile/miniGame/miniRemote.js?t=" + timestamp;
window.cocosUrl = "https://snh5-cdn1.ttagj.com/miniGame/release/";
window.loadMini = "https://snh5-cdn1.ttagj.com/miniGame/release/miniRemote.js?t=" + timestamp;

window.addEventListener('error',
    function(message, url, line, column, error) {
        browserClient('sendLog',
            {
                level: 'error',
                content: `message:${message};url:${url};line:${line};column:${column};error:${error}`
            }
        )
    }
)

// try {
//     const vConsole = new VConsole()
//     Vue.use(vConsole);
// } catch (error) {}

// browserClient('start')

Vue.use(FBSignInButton)

Vue.config.productionTip = false;

window.HCSJ_H5_Loading && window.HCSJ_H5_Loading(30);

new Vue({
    router,
    store,
    i18n,
    data: () => {
        return {
            BROWSERID_UUID: '',
        }
    },
    render: (h) => h(App),
}).$mount('#app');
